import {
  GET_SHIPMENT_TRACKING_DETAIL_FETCHING,
  HANDLE_SHIPMENT_TRACKING_RESPONSE,
} from '../actions/trackingDetails';

export const initialState = {};

export const getShipmentTrackingDetailFetching = (
  state: Object,
  action: Object
) => ({
  ...state,
  [action.meta.trackingNumber]: { isFetching: true },
});

export const pushShipmentTrackingResponseToStore = (
  state: Object,
  action: Object
) => ({
  ...state,
  [action.meta.trackingNumber]: { ...action.payload, isFetching: false },
});

const trackingDetails = (state: Object = initialState, action: Action) => {
  const newState = Object.assign({}, state);
  switch (action.type) {
    case GET_SHIPMENT_TRACKING_DETAIL_FETCHING:
      return getShipmentTrackingDetailFetching(newState, action);
    case HANDLE_SHIPMENT_TRACKING_RESPONSE:
      return pushShipmentTrackingResponseToStore(newState, action);
    default:
      return state;
  }
};

export default trackingDetails;

export const getTrackingDetails = (state: Object) => {
  if (state.trackingDetails) return state.trackingDetails;
  return {};
};
